import { GET_ORDER_LIST_SUCCESS, UPDATE_BASKET, UPDATE_ORDER_OPERATION_DATA, UPDATE_PUBLIC_BUYER } from "../action-types/order";
import StoreService from "../services/store";

// *******************************
//  GET ORDER LIST
// *******************************

export const getOrderList = (associateId) => {
    return dispatch => {
        StoreService.getOrdersByAssociate(associateId)
        .then((response) => {
            dispatch(getOrderListSuccess(response));
        })
        .catch(error => {
            //console.error(error);
            //dispatch(appError("allowances.messages.list-error"));
        });
    };
}

export const getOrderListSuccess = (orders) => {
    return  {
        type: GET_ORDER_LIST_SUCCESS,
        orders: orders
    };
}

// *******************************
//  UPDATE BASKET
// *******************************

export const updateBasket = (basketProducts, basketTrainings) => {
    return  {
        type: UPDATE_BASKET,
        products: basketProducts,
        trainings: basketTrainings
    };
}

// *******************************
//  UPDATE PUBLIC BUYER
// *******************************

export const updatePublicBuyer = (publicBuyer) => {
    return  {
        type: UPDATE_PUBLIC_BUYER,
        publicBuyer: publicBuyer
    };
}

// *******************************
//  UPDATE ORDER OPERATION DATA
// *******************************

export const updateOrderOperationData = (data) => {
    return  {
        type: UPDATE_ORDER_OPERATION_DATA,
        operation: data
    };
}